import { Badge, BadgeVariantEnum, Box, Tooltip, Typography } from '@acceso/design-system';

import { useGetScheduleFormattedDates } from '@/hooks/useGetScheduleFormattedDates';
import { FormatScheduleItemType } from '@/types/schedules';

type TableRowScheduleProps = {
  startDatetime: string;
  endDatetime: string | null;
  schedule: FormatScheduleItemType[];
};

export function TableRowSchedule({ startDatetime, endDatetime, schedule }: TableRowScheduleProps) {
  const getScheduleFormattedDates = useGetScheduleFormattedDates();
  const formattedDates = getScheduleFormattedDates({ startDatetime, endDatetime, schedule });
  const hiddenSchedules = formattedDates.schedules.slice(1);

  return (
    <Box className="flex flex-col gap-1">
      <div>
        <Typography className="text-xs font-semibold text-text-dark-10">
          {formattedDates.dateRange}
        </Typography>

        {hiddenSchedules.length > 0 ? (
          <Tooltip
            help={hiddenSchedules.map((schedule, index) => (
              <p key={index}>{schedule}</p>
            ))}
            grow
          >
            <Badge variant={BadgeVariantEnum.DefaultOutline} className="h-[14px]">
              + {hiddenSchedules.length}
            </Badge>
          </Tooltip>
        ) : null}
      </div>

      <Typography className="text-xs text-text-dark-10">{formattedDates.schedules[0]}</Typography>
    </Box>
  );
}
